export default __webpack_public_path__ + "static/media/SERKO-FU.26ffc953.png";